var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"render"},[_c('el-form-item',{attrs:{"label-width":_vm.itemRender.width,"label":_vm.itemRender.label,"required":_vm.itemRender.required ? true : false}}),_c('div',{staticClass:"div"},[_vm._v("自动计算数值")]),_c('div',{staticClass:"div"},[_vm._v(_vm._s(_vm.changeToChinese(10000))+"整 (示例)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }